import ntactlogo from "../../assets/Ntact.png";

const CaptureGuide = ({ selectedCompany, employee, setScreen }) => {

  const poses = ["Front", "Left", "Right", "Up", "Down"];

  return (
    <div className="w-auto sm:w-[600px] p-6 text-center bg-white"
     style={{
    borderRadius: "12.75px",
    boxShadow: "0 0 4px 0 rgba(179, 67, 67, 0.5)",
    borderColor: "rgba(179, 67, 67, 0.2)", 
  }}
    >
      <div className="flex justify-center mb-4">
        <img src={ntactlogo} alt="NTact Logo" className="w-24" />
      </div>

      <h2 className="text-lg font-semibold text-[#0A0A0A]">  Welcome, {employee ? `${employee.firstname} ${employee.lastname}` : ""}</h2>
      <p className="text-sm text-gray-500 mb-4">
        {selectedCompany?.name} • ID: {employee?.empid}
      </p>

      <h3 className="text-xl font-semibold text-[#0A0A0A] mb-2">
        Let's capture your face in 5 easy steps
      </h3>
      <p className="text-sm text-[#717182] mb-6">
        This app will guide you through taking 5 photos in different head poses.
        <br />Hold each pose steady when instructed.
      </p>

      <div className="grid grid-cols-5 gap-3 mb-6">
        {poses.map((pose, index) => (
          <div key={index} className="flex flex-col items-center">
            <div className="w-14 h-14 rounded-md bg-gray-100" />
            <span className="text-xs mt-2 text-[#0A0A0A]">{pose}</span>
          </div>
        ))}
      </div>

      <button
        className="w-full min-h-[50px] bg-[#0A0A0A] hover:bg-gray-800 text-white font-medium py-2 px-4 rounded"
        onClick={() => setScreen(2)}
      >
        Start Face Capture
      </button>
    </div>
  );
};

export default CaptureGuide;
